module.exports = __webpack_public_path__ + "img/shopify.0e48c524.png";